export enum EukaProgram {
  SENIOR = "Euka Senior",
  PRIMARY = "Euka Primary",
  SECONDARY = "Euka Secondary",
  CLEVER_KIDS = "Euka Clever Kids",
  SENIOR_UNI_PATHWAY = "Euka Senior University Pathway",
  SENIOR_NON_ASSESSED = "Euka Senior Non Assessed",
  LEGACY = "Euka Legacy"
}
